<form (ngSubmit)="onSubmit()">
    <div class="title-outer">
        <h2 class="form-title">{{ languageService.languageJSON.StartRollout_Title }}</h2>
    </div>

    <div class="form-section" [hidden]="loading">
        <div class="flex-row assign-bikes-title">
            <label>
                <div class="assign-bikes-detail">
                    <span>{{ languageService.languageJSON.StartApprovalRollout_SelectedSoftware }}: </span><b>{{
                        releaseId}}</b>
                </div>
                <div class="assign-bikes-detail">
                    <span>{{ languageService.languageJSON.ReleaseDetails_Name }}: </span><b>{{
                        softwareName}}</b>
                </div>
                <div class="assign-bikes-detail">
                    <span>{{ languageService.languageJSON.ComponentDetails_ComponentName }}: </span><b>{{
                        componentName}}</b>
                </div>
            </label>
        </div>
    </div>

    <app-add-rule #deactivationRule [hidden]="loading"
        [title]="languageService.languageJSON.StartRollout_AutomaticDeactivationRules"></app-add-rule>

    <app-loading-animation *ngIf="loading"></app-loading-animation>

    <div class="form-section-send" [hidden]="loading">
        <button type="submit">{{ languageService.languageJSON.Global_Save}}</button>
    </div>
</form>